var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[(_vm.getVersion && _vm.getEnvironment.length > 0)?_c('VersionInfo',{attrs:{"version":_vm.getVersion,"compilations":_vm.getCompilations,"environment":_vm.getEnvironment}}):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }